<form [formGroup]="form" class="flex flex-col">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <h2 fxFlex>
      Metoda płatności
    </h2>
  </div>
  <div
    class="payment-methods"
    fxFlex
    fxFlex.lt-md="none"
    fxLayout="column"
    fxLayoutAlign="start stretch">
    <app-payment-method-chooser (disabledMethodClicked)="onDisabledMethodClicked(payment, $event)"
                                [disabledChooser]="countPaymentFragments>0 || payment?.status === paymentStatus.STARTED"
                                [inProgress]=" payment?.status === paymentStatus.STARTED"
                                formControlName="method" [methods]="methods"
                                [amount]="payment?.totalAmount ? payment?.totalAmount : 0">
    </app-payment-method-chooser>
  </div>

  <mat-card-content
    class="credit-cards"
    *ngIf="payment?.status === paymentStatus.CREATED && step === paymentStep.CREDIT_CARDS"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxFlex
    fxFlex.lt-md="none"
  >
    <mat-radio-group fxLayout="column">
      <mat-card
        *ngFor="let creditCard of creditCards"
        (click)="!creditCard.isCreditCardDisabled && form.creditCard.setValue(creditCard.creditCardId)"
        [class.selected]="form.creditCard.value === creditCard.creditCardId"
        class="card-height"
        [class.creditCardDisabled]="creditCard.isCreditCardDisabled"
        [matTooltip]="creditCard.existsOnCurrentImojeService ? CREDIT_CARD_EXPIRED : CREDIT_CARD_MIGRATION_IS_UNDER_WAY"
        [matTooltipDisabled]="!creditCard.isCreditCardDisabled"
        fxFlex
      >
        <div fxLayout="row" fxLayoutGap="8px">
          <mat-radio-button
            [value]="creditCard.creditCardId"
            [checked]="form.creditCard.value === creditCard.creditCardId"
            (change)="!creditCard.isCreditCardDisabled && form.creditCard.setValue(creditCard.creditCardId)"
            fxLayout="row"
          >
          </mat-radio-button>

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlex class="credit-card">
            <div fxFlex="none" class="image" [style.backgroundImage]="'url(' + getImageUrl(creditCard) + ')'"></div>

            <div fxLayout="column" fxLayoutAlign="center start" fxFlex class="credit-card-description">
              <div class="description">{{ creditCard.label }}</div>
              <div [class.description]="creditCard.label === null">
                {{ getDescription(creditCard) }} •••• •••• •••• {{ getNumber(creditCard.maskedNumber) }}
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <mat-card
        (click)="form.creditCard.setValue(paymentMethodCode.NEW_CREDIT_CARD)"
        [class.selected]="form.creditCard.value === paymentMethodCode.NEW_CREDIT_CARD"
        class="card-height"
        *ngIf="appConfig?.config?.features?.addingCreditCardsEnabled"
      >
        <mat-radio-button
          [value]="paymentMethodCode.NEW_CREDIT_CARD"
          [checked]="form.creditCard.value === paymentMethodCode.NEW_CREDIT_CARD"
        >
          <div class="flex items-center">
            <app-icon name="add_circle"></app-icon>
            <div class="description">Dodaj kartę płatniczą</div>
          </div>
        </mat-radio-button>
      </mat-card>

      <mat-card
        (click)="disabledAddingCreditCards()"
        class="card-height"
        *ngIf="!appConfig?.config?.features?.addingCreditCardsEnabled"
      >
        <mat-radio-button [value]="false" [checked]="false">
          <div class="flex items-center">
            <app-icon name="add_circle"></app-icon>
            <div class="description">Dodaj kartę płatniczą</div>
          </div>
        </mat-radio-button>
      </mat-card>
    </mat-radio-group>
  </mat-card-content>

  <mat-card-content
    class="phone-number-container"
    *ngIf="payment?.status === paymentStatus.CREATED && step === paymentStep.PHONE_VERIFICATION"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxFlex
    fxFlex.lt-md="none"
  >
    <div class="phone-number-container__margin">
      Aby skorzystać z Twisto musisz zweryfikować numer telefonu.
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Numer telefonu</mat-label>
        <input
          [formControl]="form.phoneNumber"
          mask="000 000 000"
          class="w-full"
          matInput
          name="phoneNumber"
          prefix="+48 "
          inputmode="numeric"
        />
        <mat-error
          *ngIf="
            !!form.phoneNumber.errors?.minlength ||
            !!form.phoneNumber.errors?.maxlength ||
            !!form.phoneNumber.errors?.phoneNumberNotUnique
          "
        >
          Podaj poprawny numer telefonu
        </mat-error>
        <mat-error *ngIf="!!form.phoneNumber.errors?.tooManyRequests">
          Przekroczono liczbę prób. Spróbuj ponownie za 1 minutę
        </mat-error>
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-content
    class="phone-number-container"
    *ngIf="payment?.status === paymentStatus.CREATED && step === paymentStep.VERIFICATION_CODE"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxFlex
    fxFlex.lt-md="none"
  >
    <div class="phone-number-container__margin">
      <p>
        Kod weryfikacyjny został wysłany na numer
        <span class="nowrap">+48 {{ form.phoneNumber.value | mask: '000 000 000' }}</span
        ><span>.</span>
        Wpisz kod w polu poniżej.
      </p>

      <form id="phoneNumberVerificationCode">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Kod weryfikacyjny</mat-label>
          <!--Workaround for https://github.com/angular/angular/issues/14057-->
          <input
            [formControl]="form.verificationCode"
            class="w-full"
            mask="000000"
            matInput
            name="verificationCode"
            type="text"
          />

          <mat-error
            *ngIf="!form.verificationCode.untouched && form.verificationCode.dirty && !!form.verificationCode.errors"
          >
            {{
              !!form.verificationCode.errors?.invalidCode
                ? 'Kod weryfikacyjny jest nieprawidłowy lub utracił ważność'
                : 'Podaj poprawny kod veryfikacyjny'
            }}
          </mat-error>
        </mat-form-field>
      </form>

      <p>
        Nie możesz znaleźć kodu weryfikacyjnego?<br />
        <ng-container *ngIf="verificationTimer$ | async as counterValue">
          Możesz wysłać kod ponownie za {{ counterValue }}s.
        </ng-container>
        <a *ngIf="verificationTimerValue === 0" (click)="savePhoneNumber()" class="resend-btn">Wyślij ponownie.</a>
      </p>
    </div>
  </mat-card-content>

  <mat-card-content *ngIf="!!payment?.id && payment?.status === paymentStatus.STARTED" fxFlex fxFlex.lt-md="none">
    <ng-container *ngIf="payment.paymentMethodDetails.paymentMethod!==PaymentMethodCode.DEFER; ">
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px" fxFlex class="spinner-section">
        <span *ngIf="justStarted">Proszę czekać. Trwa przekierowanie na stronę operatora płatności.</span>
        <span *ngIf="!justStarted">Oczekiwanie na zaksięgowanie wpłaty. Może to potrwać do kilku minut.</span>

        <div fxFlex fxFlex.lt-md="none" fxLayout="column" fxLayoutAlign="center center">
          <mat-spinner></mat-spinner>

        </div>

        <div *ngIf="!justStarted" class="text-me flex flex-col items-center justify-center">
          <span class="mb-16">Nie udało się wykonać wpłaty? Coś poszło nie tak?</span>

          <span class="mb-18 payment-result-try-again-text" *ngIf="timer$ | async as counterValue"
          >Możesz ponowić płatność za {{ counterValue }}s.</span
          >

          <ng-container *ngIf="timerValue === 0">
            <!--            <app-new-loader-button [loading]="buttonLoading" (buttonClick)="restartPayment(payment)">-->
            <!--              <span class="payment-result-try-again-text">Spróbuj ponownie</span>-->
            <!--            </app-new-loader-button>-->
          </ng-container>
        </div>
      </div>
    </ng-container>
  </mat-card-content>

  <mat-card-content
    *ngIf="payment?.status === paymentStatus.COMPLETED || payment?.status === paymentStatus.AUTOMATIC_COMPLETED"
    fxFlex
    fxFlex.lt-md="none"
  >
    <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
      <app-success-animation [size]="200" color="#6c9300"></app-success-animation>

      <div class="flex flex-col">
        <span class="status-ok">Płatność zakończona sukcesem.</span>
        <app-new-loader-button
          [customType]="LoaderButtonType.RAISED"
          color="accent"
          class="flex flex-col mb-10"
          routerLink="/dashboard">
          Ok
        </app-new-loader-button>
        <app-new-loader-button
          class="flex flex-col"
          *ngIf="showSetupAutomaticPaymentButton(payment) && this.appConfig.config.payment.autoPayment.enabled"
          (click)="setupAutoPayment(payment)"
        >Ustaw autopłatność
        </app-new-loader-button>
      </div>
    </div>
  </mat-card-content>

  <mat-card-content
    *ngIf="payment?.status === paymentStatus.FAILED || payment?.status === paymentStatus.AUTOMATIC_FAILED"
    fxFlex
    class.xs="flex-none"
  >
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px" fxFlex>
      <span class="status-error">Nie można zrealizować płatności</span>

      <!--      <app-new-loader-button (buttonClick)="restartPayment(payment)">Spróbuj ponownie</app-new-loader-button>-->
    </div>
  </mat-card-content>

  <mat-card-content *ngIf="payment?.status === paymentStatus.CANCELLED" fxFlex fxFlex.lt-md="none">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px" fxFlex>
      <span class="status-error">Płatność została anulowana</span>
      <!--      <app-new-loader-button (buttonClick)="restartPayment(payment)">Spróbuj ponownie</app-new-loader-button>-->
    </div>
  </mat-card-content>

  <app-express-payment
    *ngIf=" appConfig.config.payment.express.enabled &&
      payment?.status === paymentStatus.CREATED &&
      payment?.liabilitiesPaymentType !== LiabilitiesPaymentType.TOP_UP
    "
    [payment]="payment"
    [showRecommendation]="showExpressPaymentRecommendation"
    (expressPaymentChanged)="expressPaymentChanged.emit($event)"
  >
  </app-express-payment>


  <!--todo do przeniesienia-->
  <div *ngIf="false &&(payment?.status === paymentStatus.CREATED || !payment) " fxLayout="row">
    <div *ngIf="step === paymentStep.CREDIT_CARDS">
      <app-new-loader-button
        *ngIf="form.creditCard.value !== paymentMethodCode.NEW_CREDIT_CARD"
        (buttonClick)="initPayment(payment)"
        [disabled]="!form.creditCard.value || !payment"
        [loading]="buttonLoading"
        id="register-button"
        [customType]="LoaderButtonType.RAISED"
        color="accent"
      >
        Opłać2
      </app-new-loader-button>

      <button
        mat-raised-button
        *ngIf="form.creditCard.value === paymentMethodCode.NEW_CREDIT_CARD"
        [routerLink]="[addCardRedirectUrl]"
        [queryParams]="{ returnPath: addCardReturnUrl, liabilitiesPaymentType: payment.liabilitiesPaymentType }"
        color="primary"
      >
        Dalej
      </button>
    </div>

    <app-new-loader-button
      *ngIf="step === paymentStep.PHONE_VERIFICATION"
      (buttonClick)="savePhoneNumber()"
      [disabled]="form.phoneNumber.invalid"
      [loading]="buttonLoading"
      [customType]="LoaderButtonType.RAISED"
      color="accent"
    >
      Dalej
    </app-new-loader-button>
    <app-new-loader-button
      *ngIf="step === paymentStep.VERIFICATION_CODE"
      (buttonClick)="verifyPhoneNumber()"
      [disabled]="form.verificationCode.invalid"
      [loading]="buttonLoading"
      [customType]="LoaderButtonType.RAISED"
      color="accent"
    >
      Zapisz
    </app-new-loader-button>
    <app-new-loader-button
      *ngIf="step === paymentStep.METHODS"
      (buttonClick)="next(payment)"
      [disabled]="!form.methodSelected"
      [loading]="buttonLoading"
      [customType]="LoaderButtonType.RAISED"
      color="accent"
    >
      {{
        form.method.value === paymentMethodCode.CREDIT_CARD ||
        form.method.value === paymentMethodCode.AUTO_PAYMENT ||
        (form.method.value === paymentMethodCode.TWISTO &&
          payment.availablePaymentMethods[paymentMethodCode.TWISTO] === paymentMethodAvailability.NO_PHONE_NUMBER)
          ? 'Dalej'
          : 'Opłać1'
      }}
    </app-new-loader-button>

    <button
      mat-button
      class="font-medium"
      *ngIf="step === paymentStep.CREDIT_CARDS || step === paymentStep.PHONE_VERIFICATION"
      (click)="step = paymentStep.METHODS"
    >
      Wróć
    </button>
    <app-new-loader-button
      *ngIf="step === paymentStep.METHODS"
      (buttonClick)="cancelPayment(payment.id)"
      [loading]="buttonLoading"
      type="standard"
      class="font-medium"
      [disabled]="!payment"
    >
      Opróżnij koszyk
    </app-new-loader-button>
  </div>

</form>
